import React, { memo } from 'react';
import { connect } from 'react-redux';

import BreadCrumbComponent from '../GeneralForm/BreadCrumbComponent';

const PageHeading = ({
  tag: Tag = 'h1',
  pageName = '',
  pageSmallName = '',
  className = '',
  onClick = null,
  otherRenderElement = null,
  pageTitle,
  pageBreadCrumb
}) => {
  return (
    <div className={`mb-0 ${className}`}>
      <Tag className="mb-0">
        <span className="clickable" onClick={onClick}>
          {pageName ? pageName : pageTitle}
          {pageSmallName && <span className="fs-18 ml-1">{pageSmallName}</span>}
        </span>
      </Tag>
      {!pageName && <BreadCrumbComponent breadcrumbs={pageBreadCrumb} />}
      {otherRenderElement}
    </div>
  );
};

const mapStateToProps = state => ({
  pageTitle: state.mainlayout.pageTitle,
  pageBreadCrumb: state.mainlayout.pageBreadCrumb
});

PageHeading.displayName = 'PageHeading';
export default connect(mapStateToProps)(memo(PageHeading));
